<!-- 520活动专场 -->
<template>
  <div class="contianer">
    <div class="con">
      <img
        class="bgimg"
        src="../../assets/images/h5_230721/1080_01.jpg"
        alt=""
      />
      <div class="ac2_img">
        <div>
          <img
            alt=""
            src="../../assets/images/h5_230721/1080_02.jpg"
            @click="goto('8735')"
          />
        </div>
        <div>
          <img
            alt=""
            src="../../assets/images/h5_230721/1080_03.jpg"
            @click="goto('19933')"
          />
        </div>
      </div>
      <div class="ac2_img">
        <div>
          <img
            alt=""
            src="../../assets/images/h5_230721/1080_04.jpg"
            @click="goto('22384')"
          />
        </div>
        <div>
          <img
            alt=""
            src="../../assets/images/h5_230721/1080_05.jpg"
            @click="goto('22382')"
          />
        </div>
      </div>
      <div class="ac2_img">
        <div>
          <img
            alt=""
            src="../../assets/images/h5_230721/1080_06.jpg"
            @click="goto('22377')"
          />
        </div>
        <div>
          <img
            alt=""
            src="../../assets/images/h5_230721/1080_07.jpg"
            @click="goto('22373')"
          />
        </div>
      </div>
      <div class="ac2_img">
        <div>
          <img
            alt=""
            src="../../assets/images/h5_230721/1080_08.jpg"
            @click="goto('21329')"
          />
        </div>
        <div>
          <img
            alt=""
            src="../../assets/images/h5_230721/1080_09.jpg"
            @click="goto('22274')"
          />
        </div>
      </div>
      <div class="ac2_img">
        <div>
          <img
            alt=""
            src="../../assets/images/h5_230721/1080_10.jpg"
            @click="goto('9823')"
          />
        </div>
        <div>
          <img
            alt=""
            src="../../assets/images/h5_230721/1080_11.jpg"
            @click="goto('22428')"
          />
        </div>
      </div>
      <div class="ac2_img">
        <div>
          <img
            alt=""
            src="../../assets/images/h5_230721/1080_12.jpg"
            @click="goto('20464')"
          />
        </div>
        <div>
          <img
            alt=""
            src="../../assets/images/h5_230721/1080_13.jpg"
            @click="goto('21019')"
          />
        </div>
      </div>
      <div class="ac2_img">
        <div>
          <img
            alt=""
            src="../../assets/images/h5_230721/1080_14.jpg"
            @click="goto('21614')"
          />
        </div>
        <div>
          <img
            alt=""
            src="../../assets/images/h5_230721/1080_15.jpg"
            @click="goto('21431')"
          />
        </div>
      </div>
      <div class="ac2_img">
        <div>
          <img
            alt=""
            src="../../assets/images/h5_230721/1080_16.jpg"
            @click="goto('20575')"
          />
        </div>
        <div>
          <img
            alt=""
            src="../../assets/images/h5_230721/1080_17.jpg"
            @click="goto('18844')"
          />
        </div>
      </div>
      <div class="ac2_img">
        <div>
          <img
            alt=""
            src="../../assets/images/h5_230721/1080_18.jpg"
            @click="goto('7833')"
          />
        </div>
        <div>
          <img
            alt=""
            src="../../assets/images/h5_230721/1080_19.jpg"
            @click="goto('22046')"
          />
        </div>
      </div>
      <div class="ac2_img">
        <div>
          <img
            alt=""
            src="../../assets/images/h5_230721/1080_20.jpg"
            @click="goto('9530')"
          />
        </div>
        <div>
          <img
            alt=""
            src="../../assets/images/h5_230721/1080_21.jpg"
            @click="goto('19720')"
          />
        </div>
      </div>
      <img
        class="bgimg"
        src="../../assets/images/h5_230721/1080_22.jpg"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'mayTwenty2',
  methods: {
    goto(id) {
      let position = window.scrollY;
      this.$router.push({query: {page: position}});
      this.$router.push({
        path: '/productDetails?id=' + id,
      });
    },
  },
  mounted() {
    let recruitScrollY = this.$route.query.page;
    window.scroll(0, recruitScrollY);
  },
};
</script>
<style lang='scss' scoped>
img {
  border: 0;
  margin: 0;
  padding: 0;
  vertical-align: middle;
  width: 100%;
}
.con {
  .ac1_img,
  .ac2_img {
    display: flex;
    img {
      cursor: pointer;
    }
  }
  .ac3_img {
    display: flex;
    img {
      cursor: pointer;
    }
  }
}
</style>